import React, { useEffect, useState, useRef } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import Select from 'react-select';
import ApiCallServices from "../../../../services/ApiCallServices";
import { END_POINTS } from '../../../../services/endpoint/endPoint';
import button from "../../../button.module.css";
import PartnersList from './child/PartnersList';

const Partners = () => {
  const initialState = {
    name: '',
    email: '',
    currency: '',
    contact: '',
    address: '',
    logo: '',
    description: ''

  }
  const [partnerList, setPartnerList] = useState([])
  const [showHideModal, setShowHideModal] = useState(false)
  const [createPartner, setCreatePartner] = useState(initialState)
  const [searchBy, setSearchBy] = useState()
  const [isEditMode, setIsEditMode] = useState()
  const fileInputRef = useRef(null);
  const [errors, setErrors] = useState()

  const getAllPartners = () => {
    let data = {
      name: searchBy || '',
    }
    ApiCallServices.create(END_POINTS.supplyPartnerList, data).then((res) => {
      if(res.status == 200){
        setPartnerList(res.data.data)
        
      }
    })
    .catch((error) => {
      // Handle errors here
      if (error.response) {
          toast.error(error, {
              position: "top-right"
          });
          console.log(error.response, "===>error in getting response");
      } 
  });
  }

  const validateForm = () => { 
    const errors = {};
    
    if (!createPartner?.name) errors.name = "Name is required";
    if (!createPartner?.email) errors.email = "Email is required";
    if (!createPartner?.currency ) errors.currency = "Currency is required";
    if (!createPartner?.logo && !isEditMode ) errors.logo = "Logo is required";
    
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const createNewPartner = (e) => {
    e.preventDefault()
    if(!validateForm()){
      return;
    }

    const formData = new FormData();
    formData.append("id", createPartner.id);
    formData.append("logo", createPartner.logo ? createPartner.logo : '');
    formData.append("name", createPartner.name);
    formData.append("email", createPartner.email);
    formData.append("currency", createPartner.currency);
    formData.append("contact", createPartner.contact ? createPartner.contact : '');
    formData.append("address", createPartner.address ? createPartner.address : '');
    formData.append("description", createPartner.description ? createPartner.description : '');

    document?.body?.removeAttribute('style');

    if(isEditMode){
      ApiCallServices.fileUpload(END_POINTS.updateSupplyPartner, formData).then((res) => {
        if(res.status == 200){
          toast.success("updated partner", {
            position: "top-right"
        });
          setIsEditMode(false)
          setCreatePartner(initialState)
          setShowHideModal(false)
          getAllPartners()
        }
      })
    }
    else {
      ApiCallServices.fileUpload(END_POINTS.createSupplyPartner, formData).then((res) => {       
        if(res.status == 200){         
          setIsEditMode(false)
          setCreatePartner(initialState)
          setShowHideModal(false)
          getAllPartners()
          // Clear the file input field
          if (fileInputRef.current) {
            fileInputRef.current.value = '';
          }
          toast.success("created new partner", {
            position: "top-right"
        });
          
        }
      })
      .catch((error) => {
        // Handle errors here
        if (error.response) {
            toast.error("err in creating", {
                position: "top-right"
            });
            console.log(error.response.data, "===>error in getting response");
        } 
      });
    }
    
  }

  const getPartnerById = (id) => {
    ApiCallServices.create(END_POINTS.getPartnerById, {id:id}).then((res) => {
      if(res.status === 200){
        setShowHideModal(true)
        document.body.style = 'overflow: hidden'
        setIsEditMode(true)
        setCreatePartner(res.data.data)
        
      }
    })
    .catch((errors) => {
      console.log(errors, "===***errors")
    })
  }

  const handleHideShowModal = () => {
    setShowHideModal(true)
    document.body.style = 'overflow: hidden'
  }

  useEffect(()=> {
    getAllPartners();
  }, [searchBy])

  const handleOnChangeInput = (e) => {
    setCreatePartner((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  }

  const uploadImage = (e) => {
    console.log(e.target.files[0], "*****9999")
    setCreatePartner((prevState) => ({
      ...prevState,
      logo: e.target.files[0],
    }));
  }

  const closeModal = () => {
    setCreatePartner(initialState)
    setShowHideModal(false)
    document?.body?.removeAttribute('style');
    setErrors({})
    setIsEditMode(false)
     // Clear the file input field
     if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
    
  }

  const searchFilter = (e) => {
    if(e.target.value.length > 1){
      setSearchBy(e.target.value)
    } else {
      setSearchBy('')
    }
  }

  const updatePartnerStatus = (id, status) => {
    ApiCallServices.create(END_POINTS.supplyPartnerStatus, {id: id, status: status}).then((res) => {
      
      if (res.status === 200) {
        toast.success(res.data.message, {
          position: "top-right"
        });
        getAllPartners();
      }
    })
    .catch((error) => {
      if (error.response) {
        toast.error(error.response.data.error, {
          position: "top-right"
      });
        console.log(error.response, "===>error in getting response status****");
      } 
    });
  }
  const confirmUpdate = (id, status) => {
    if (window.confirm('Are you sure you want to Update this User')) {
      updatePartnerStatus(id,status);
    }
}
  
console.log(partnerList, "****partnerList")
  return (
    <>
      <ToastContainer />
      <div className="container-fluid">


      <div className='filter-wraper justify-content-between'>
          <div className='d-flex align-items-center fields'>
              <h3>Manage Supply Partners</h3>
          </div>
      </div>


        <div className='filter-wraper d-flex justify-content-between'>
          <div className='d-flex align-items-center fields'>
            <div className='form-group search-icon'>
              <input type='text' className='form-control' placeholder='Search name & email' onChange={searchFilter}/>
            </div>
          </div>
          <div className='form-group d-flex justify-content-end'>
            <button type="button" className={`${button.btn} ${button.btnDarkBlue}`} onClick={handleHideShowModal}>Add New Supply Partner</button>
          </div>
        </div>
        <PartnersList partnerList={partnerList} updateStatus = {confirmUpdate} getPartnerById= {getPartnerById} />
      </div>
      {/* add Supply partner modal */}
      <div className={`modal form-modal ${showHideModal ? 'show' : ''}`}>
        <div className="modal-dialog modal-md">
            <div className="modal-content">           
              <div className="modal-header">
                  <h4 className="modal-title">{isEditMode ? 'Update Supply Partner' : 'Add New Supply Partner'}</h4>
                  <i className="fa-regular fa-circle-xmark close-icon" onClick={closeModal}></i>
              </div>
              
              <div className="modal-body">
                  <form onSubmit={createNewPartner}>
                      <div className="form-wraper">
                          <div className="form-group">
                              <label>Name <span className="astric">*</span></label>
                              <input type="text" placeholder="Enter Supply Partner Name"  name= "name" className="form-control" value={createPartner?.name} onChange={handleOnChangeInput}/>
                              {errors?.name && <div className="input-error">{errors.name}</div>}
                          </div>
                          <div className="form-group">
                              <label>Email <span className="astric">*</span></label>
                              <input type="text" placeholder="Email" name= "email" className="form-control" value={createPartner?.email} onChange={handleOnChangeInput}/>
                              {errors?.email && <div className="input-error">{errors.name}</div>}
                          </div>
                          <div className="form-group">
                              <label>Currency <span className="astric">*</span></label>
                              <select className='form-control' name= "currency" value={createPartner.currency} onChange={handleOnChangeInput}>
                                <option >Select Currency</option>
                                <option value="EUR"> EUR</option>
                                <option value="USD"> USD </option>
                              </select>
                              {errors?.currency && <div className="input-error">{errors.currency}</div>}
                              {/* <input type="text" placeholder="Currency"  className="form-control" value={createPartner?.currency} onChange={handleOnChangeInput}/>
                              {errors?.currency && <div className="input-error">{errors.currency}</div>} */}
                          </div>
                          <div className="form-group">
                              <label>Logo image {!isEditMode && <span className="astric">*</span>}</label>
                              <input type="file" name='logo' className="form-control" ref={fileInputRef}  onChange={uploadImage}/>
                              {errors?.logo &&  <div className="input-error">{errors.logo}</div>}
                          </div>
                          <div className="form-group">
                              <label>Contact No </label>
                              <input type="number" placeholder="Contact No" name= "contact" className="form-control" value={createPartner?.contact} onChange={handleOnChangeInput} />
                          </div>
                          <div className="form-group">
                              <label>Address </label>
                              <textarea className='form-control' placeholder='Enter Address' name='address' value={createPartner?.address} onChange={handleOnChangeInput} ></textarea>
                          </div>
                          <div className="form-group">
                              <label>Comments </label>
                              <textarea className='form-control' name='description' placeholder='Enter Comments' value={createPartner?.description} onChange={handleOnChangeInput}  ></textarea>
                          </div>
                          <div className="text-end">
                              <button type="submit" className={`${button.btn} ${button.btnBlue}`} >{isEditMode ? 'Update' : 'Create'}</button>
                          </div>
                      </div>
                  </form>
              </div>
            </div>
        </div>
      </div>
      <div className={`${showHideModal ? 'overlay' : ''}`}></div>
    </>
  );
};

export default Partners;